import * as Yup from 'yup';

const schemaEmail = Yup.object().shape({
  email: Yup.string()
    .email('Masukkan alamat email yang valid.')
    .required('Email harus diisi')
    .max(234, 'Email tidak boleh lebih dari 234 karakter.')
});

export default schemaEmail;